import { Helmet } from "react-helmet";
import {
    Box,
    ClickAwayListener,
    Stack,
    MenuItem,
    MenuList,
    Divider,
    InputAdornment,
    TextField,
    Tab,
    Tabs,
    Select,
    Container,
    Grid,
    Typography,
    Button,
    usePagination,
    Grow,
    Popper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Paper
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import AccessibleIcon from "@mui/icons-material/Accessible";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import React, { useEffect, useMemo } from "react";
import { DropResult, DragDropContext, Droppable, OnDragEndResponder, Draggable } from 'react-beautiful-dnd';
import DraggableList from '../DraggableList';
import manageForm from "../../../../services/manageForm.service";
import cssVariables from "../../../../theme/cssVariables";
import { ReactComponent as Doner } from "../../../../assets/icons/doner.svg";
import { ReactComponent as XIcon } from "../../../../assets/icons/xIcon.svg";
import { useSelector, useDispatch } from "react-redux";
import TableData from "./TableData";

const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const ManageForm = () => {
    const useStyles = makeStyles({
        select: {
            '& div ': {
                padding: "8.5px 8.5px 8.5px 15px"
            },
        },
        dateTimePicker: {
            display: "flex !important",
            flexDirection: "column !important",
            justifyContent: "space-between !important",
            position: "relative",
            marginBottom: "14px !important",

        },
        plusSvg: {
            "& > path": {
                fill: "#fff",
                stroke: "#fff",
            },
        },
        input: {
            '& div > input': {
                height: '7px',
                position: "relative"
            }
        },
        draggingListItem: {
            background: 'rgb(235,235,235)'
        },
        toggleBtnRoot: {
            background: `transparent !important`,
            color: "#6B6B6B !important",
            width: "320px",
            border: "none !important",
        },
        toggleBtnSelected: {
            background: `${cssVariables.color.primary}!important`,
            color: "#fff!important",
        },
        flexPaper: {
            flex: 1,
            minWidth: 350,
            "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
            "border-radius": "10px !important        "
        },
        tab: {
            "text-transform": "none !important",
            fontSize: "16px !important",
            fontWeight: "400 !important",
            color: "#A3A3A3 !important",
        },
        root: {
            display: 'flex',
            width: "100%",
            flexWrap: 'wrap'
        }
    })
    const [mainItems, setMainItems] = React.useState([]);
    const [dataFilterCycleType, setDataFilterCycleType] = React.useState([]);
    const [dataFilter, setDataFilter] = React.useState({});
    const [openAdvanceFilters, setOpenAdvanceFilters] = React.useState(true);
    const [sumFilter, setSumFilter] = React.useState(0);
    let { serial } = useParams()
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [value, setValue] = React.useState('active');
    const [cycleType, setCycleType] = React.useState('');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    let getCycleType = () => {
        manageForm.getFilterCycleType().then((rs) => {
            setDataFilterCycleType(rs?.data?.cycle_type)
        }).catch((err) => {

        })
    }
    useEffect(() => {
        getCycleType()
    }, []);

    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const [isCollapse, setIsCollapse] = React.useState(false);
    const onScroll = () => {
        if (isCollapse) {
            setIsCollapse(false)
        }
    }
    const emitCollapse = () => {
        setIsCollapse(true)
    }

    const checkFilterData = () => {
        let total = 0
        // if (Util.formatData(employee, false) !== false) {
        //     total += 1
        // }
        // if (Util.formatData(position, false) !== false) {
        //     total += 1
        // }
        // if (Util.formatData(team, false) !== false) {
        //     total += 1
        // }
        // if (Util.formatData(cycle, false) !== false) {
        //     total += 1
        // }
        // if (Util.formatData(templateType, false) !== false) {
        //     total += 1
        // }
        // if (Util.formatData(workflowTemplate, false) !== false) {
        //     total += 1
        // }
        // if (Util.formatData(workflowStatus, false) !== false) {
        //     total += 1
        // }
        // if (Util.formatData(endDate, false) !== false) {
        //     total += 1
        // }
        // if (Util.formatData(startDate, false) !== false) {
        //     total += 1
        // }
        return total;
    }
    const onOpenAdvanceFilters = () => {
        setOpenAdvanceFilters(!openAdvanceFilters)
    }
    const handleCancel = () => {
        // setEmployee("")
        // setPosition("")
        // setTeam("")
        // setCycle("")
        // setTemplateType("")
        // setWorkflowTemplate("")
        // setWorkflowStatus("")
        // setStartDate(null)
        // setEndDate(null)
        setOpenAdvanceFilters(false)
        // dataSerachs(mainItems)
    }
    let setSum = (data) => {
        setSumFilter(data)
    }
    const handleCycleType = (data) => {
        setCycleType(data)
    }
    return (
        <Box onScroll={onScroll} style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.end} >{t('label.manageForm')}</span></Typography>
                    </Grid>
                    <Grid container item >
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="7px" pb="25px">
                            <Typography variant="h2" fontWeight="600" color="#404349" fontSize={36} lineHeight="40px" >
                                {t('label.manageForm')}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item sx={{ height: "100%" }}>
                            <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", ".MuiTabs-indicator": { backgroundColor: value === "deleted" ? "#CC6058 !important" : "#5DA196 !important" }, '.Mui-selected': { color: value === "deleted" ? "#CC6058 !important" : "#5DA196 !important" } }}>
                                <Tabs
                                    value={value}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    onChange={handleChange}
                                    TabIndicatorProps={{
                                        style: {
                                            height: "8px",
                                        },
                                    }}
                                >
                                    <Tab label={`Active`} value={`active`} classes={{ root: classes.tab }} />
                                    <Tab label={`Deleted`} value={`deleted`} classes={{ root: classes.tab }} />
                                </Tabs>
                                <Box display="flex">
                                    <Box onClick={onOpenAdvanceFilters} ml="30px" px="11px" py="8px" sx={{ height: "45px", display: "flex", border: openAdvanceFilters === false ? "1px solid #DADADA" : "1px solid #5DA196", "border-radius": "5px", "align-items": "center", background: openAdvanceFilters === true ? "#E7F1EF" : "", cursor: "pointer", "&:hover": { background: openAdvanceFilters === false ? "#E7F1EF" : "#D8ECE9", border: openAdvanceFilters === false ? "1px solid #5DA196" : "1px solid #5DA196" } }}>
                                        <Doner />
                                        <Typography pl="10px" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.advanceFilters')}</Typography>
                                        {sumFilter > 0 ?
                                            <Box ml="10px" px="12px" sx={{ background: "#5DA196", "border-radius": "50%", height: "27px", width: "27px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <Typography variant="subtitle1" fontWeight="500" color="#FFFFFF" fontSize={16} lineHeight="17.6px" display="flex">{sumFilter}</Typography>
                                            </Box>
                                            :
                                            null
                                        }
                                    </Box>
                                </Box>
                            </Box>
                            <TableData emitCollapse={emitCollapse} openAdvance={openAdvanceFilters} changeOpenAdvance={onOpenAdvanceFilters} dataCycleType={handleCycleType} setSum={setSum} dataFilterCycleType={dataFilterCycleType} scroll={isCollapse} open={value === "active"} type="active" />
                            <TableData emitCollapse={emitCollapse} openAdvance={openAdvanceFilters} dataFilterCycleType={dataFilterCycleType} dataCycleType={handleCycleType} scroll={isCollapse} open={value === "deleted"} type="deleted" />
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box >
    );
};
export default ManageForm;
